"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkRecordActionType = exports.CollectionAccessTypes = void 0;
var CollectionAccessTypes;
(function (CollectionAccessTypes) {
    CollectionAccessTypes["PRIVATE"] = "PRIVATE";
    CollectionAccessTypes["RESTRICTED"] = "RESTRICTED";
    CollectionAccessTypes["TEAM"] = "TEAM";
    CollectionAccessTypes["PUBLIC"] = "PUBLIC";
})(CollectionAccessTypes || (exports.CollectionAccessTypes = CollectionAccessTypes = {}));
var LinkRecordActionType;
(function (LinkRecordActionType) {
    LinkRecordActionType["CONNECTED"] = "CONNECTED";
    LinkRecordActionType["CREATED"] = "CREATED";
    LinkRecordActionType["UPDATED"] = "UPDATED";
    LinkRecordActionType["DELETED"] = "DELETED";
    LinkRecordActionType["EMBEDDED"] = "EMBEDDED";
    LinkRecordActionType["REMOVED"] = "REMOVED";
    LinkRecordActionType["ERRORED"] = "ERRORED";
})(LinkRecordActionType || (exports.LinkRecordActionType = LinkRecordActionType = {}));
